module.exports = __webpack_public_path__ + "static/media/COUNTERCLOCKWISE.e8a70c4b.svg";